import { Container, Typography, Button } from '@mui/material';
import NoMatchesIcons from 'components/icons/NoMatchesIcons';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { appLinks } from 'routes/routes';
import { useSWRConfig } from 'swr';

const SimpleErrorPlaceholder: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const { cache } = useSWRConfig();

  return (
    <>
      <Container
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          height: '100vh',
          justifyContent: 'center',
        }}
      >
        <Container
          maxWidth={'xs'}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <NoMatchesIcons sx={{ fontSize: { xs: 150, md: 200 }, mb: { xs: 4, md: 6 } }} />

          <Typography variant='h1' textAlign='center'>
            {t('notFoundPage.title')}
          </Typography>
          <Typography variant='body1' textAlign='center'>
            {t('notFoundPage.text')}
          </Typography>
          <Button
              component={NavLink}
              to={appLinks.discover.link}
              variant='outlined'
              size='large'
              sx={{ mt: 2 }}
              onClick={() => {
                console.log('onClick');
                Array.from(cache.keys()).forEach((key) => {
                  cache.delete(key);             
                });                      
              caches.keys().then(function (names) {
                for (const name of names) {
                  caches.delete(name);
                }
              }).finally(() => {              
                sessionStorage.clear();
                window.location.reload();
              });
            }}
          >            
          {t('notFoundPage.home')}
          </Button>
        </Container>
      </Container>
    </>
  );
};

export default SimpleErrorPlaceholder;

